var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 px-3",attrs:{"fluid":""}},[_c('app-kpihome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }